export const FINANCIAL_INSTITUTION_ID = 'financialInstitutionId';
export const PROFILE_ACCESS_ID = 'profileAccessId';
export const ACCESS_FINANCIAL_INSTITUTION_ID = 'accessFinancialInstitutionId';
export const ACCESS_COMPANY_ID = 'companyId';
